// extracted by mini-css-extract-plugin
export default {"walletChip":"styles_walletChip__wboO1","walletAvatar":"styles_walletAvatar__6Uzig","logoImg":"styles_logoImg__k1CxY"};